type Props = {
  showBelow: boolean;
};

/*
// visual indicator showing where a dragged row will land
// appears above or below the target row based on drag direction
*/
export const DropIndicator = ({ showBelow }: Props) => {
  return (
    <div
      style={{
        position: "absolute",
        top: showBelow ? "auto" : "-20px",
        bottom: showBelow ? "-20px" : "auto",
        left: "0",
        height: "2px",
        backgroundColor: "#3c1283",
        zIndex: 1000,
        pointerEvents: "none",
        width: "clamp(800px, 70vw, 1400px)",
      }}
    />
  );
};
